<template>
  <div class="input-row">
    <div class="img-box">
      <img :src="iconSrc" />
    </div>
    <input
    :type="inputType"
    :placeholder="placeholderText"
    v-model="value"
    @input="sendValue()"
    />
  </div>
</template>

<script>
export default {
  name: 'InputRow',
  mixins: [],
  components: {},
  props: {
    iconSrc:{
      type:String,
      default:''
    },
    inputType:{
      type:String,
      default:'text'
    },
    placeholderText:{
      type:String,
      default:''
    }
  },
  data() {
    return {
      value:''
    }
  },
  computed: {},
  watch: {},
  created() {
  },
  mounted() {
  },
  destroyed() {
  },
  methods: {
    sendValue(){
      this.$emit('receive',this.value)
    }
  }
}
</script>

<style lang="scss" scoped>
  .input-row{
    display: flex;
    flex-direction: row;
    align-items: center;
    width: auto;
    height: calc(var(--raito) * 47px);
    background-color: #fff;
    padding: 0 calc(var(--raito) * 14px);
    border-radius: calc(var(--raito) * 5px);
    margin-bottom: calc(var(--raito) * 13px);
    .img-box{
      width: calc(var(--raito) * 15px);
      img{
      width: calc(var(--raito) * 15px);
      height:auto;
    }
    }

    input{
      width: 100vw;
      height: calc(var(--raito) * 19px);
      margin-left: calc(var(--raito) * 10px);
      font-size: calc(var(--raito) * 14px);
      border: none;
      ::placeholder{
        font-family: PingFangSC-Regular;
        color: #CED3E0;
      }
    }

  }
</style>